module.exports = __webpack_public_path__ + "img/altus-logo.94bf9eb1.svg";